import {IMutableContext, IVariant, UnleashClient} from '@unleash/proxy-client-react';

export class FeatureFlagsService {
    client: UnleashClient = null;

    getConfig = () => {
        const hostName = window.location.hostname;
        const apiBaseUrl = hostName == 'localhost' ? 'http://localhost:3030' : 'https://' + hostName;

        return {
            url: apiBaseUrl + '/proxy',
            clientKey: 'aecb9243f3209c340e5f79b4079e98287ba0035204a5c3d762c2731c',
            appName: 'app',
            environment: 'production'
        };
    }

    createClient = () => {
        this.client = new UnleashClient(this.getConfig());

        return this.client;
    }

    updateContext = async (context: IMutableContext) : Promise<void> => {
        await this.client.updateContext(context);
    }

    isEnabled = (toggleName: string): boolean => this.client.isEnabled(toggleName);
    getVariant = (toggleName: string): IVariant => this.client.getVariant(toggleName);
}


